var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.modalIsVisible)?_c('BarcodeReaderModal',{on:{"close":_vm.closeBarcodeReader}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){_vm.modalIsVisible = true}}},[_c('i',{staticClass:"fa fa-fw fa-barcode"}),_vm._v(" Сканировать\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5a747a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/stock/features/inventory/BarcodeButton.vue
// module id = null
// module chunks = 